module.exports = __webpack_public_path__ + "img/x-close.fcac688c.svg";